import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Keeps <link rel="canonical"> self-referencing (site origin from index.html + current path, no query).
export default function CanonicalTag() {
  const { pathname } = useLocation();
  useEffect(() => {
    const link = document.querySelector('link[rel="canonical"]');
    if (!link) return;
    const origin = new URL(link.getAttribute("data-origin") || link.href).origin;
    link.setAttribute("data-origin", origin);
    link.href = origin + (pathname === "/" ? "/" : pathname.replace(/\/+$/, ""));
  }, [pathname]);
  return null;
}
